var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  BadgeSchema: () => BadgeSchema,
  BadgeTemplateSchema: () => BadgeTemplateSchema,
  BadgesService: () => BadgesService,
  CompanyService: () => CompanyService,
  appointmentSelectionStrategy: () => appointmentSelectionStrategy,
  classSelectionStrategy: () => classSelectionStrategy,
  client: () => client
});
module.exports = __toCommonJS(src_exports);

// src/schemas.gen.ts
var BadgeTemplateSchema = {
  type: "object",
  properties: {
    title: {
      type: "string"
    },
    description: {
      type: "string"
    },
    criteriaTotal: {
      type: "integer",
      minimum: 1
    },
    criteria: {
      type: "object",
      properties: {
        appointmentSelectionStrategy: {
          type: "string",
          enum: ["ALL", "NONE", "SPECIFIC"],
          description: "The strategy used for selection.",
          example: "ALL"
        },
        classSelectionStrategy: {
          type: "string",
          enum: ["ALL", "NONE", "SPECIFIC"],
          description: "The strategy used for selection.",
          example: "ALL"
        },
        includeEvents: {
          type: "boolean",
          description: "Whether events are included in the criteria.",
          example: true
        },
        includeOpenGym: {
          type: "boolean",
          description: "Whether open gym access is included in the criteria.",
          example: false
        },
        selectedAppointmentTypeIds: {
          type: "array",
          nullable: true,
          items: {
            type: "string"
          },
          description: "Array of selected appointment type IDs, if any.",
          example: ["apt-1", "apt-2"]
        },
        selectedClassIds: {
          type: "array",
          nullable: true,
          items: {
            type: "string"
          },
          description: "Array of selected class IDs, if any.",
          example: ["class-1", "class-2"]
        }
      },
      required: [
        "appointmentSelectionStrategy",
        "classSelectionStrategy",
        "includeEvents",
        "includeOpenGym"
      ],
      description: "Criteria configuration for selection strategies.",
      example: {
        appointmentSelectionStrategy: "SPECIFIC",
        classSelectionStrategy: "ALL",
        includeEvents: true,
        includeOpenGym: false,
        selectedAppointmentTypeIds: ["apt-1", "apt-2"],
        selectedClassIds: ["class-1", "class-2"]
      }
    },
    uuid: {
      type: "string"
    },
    startTime: {
      type: "string"
    },
    endTime: {
      type: "string"
    },
    createdAt: {
      type: "string"
    },
    updatedAt: {
      type: "string"
    }
  },
  required: [
    "title",
    "criteriaTotal",
    "criteria",
    "uuid",
    "startTime",
    "endTime",
    "createdAt",
    "updatedAt"
  ],
  description: "BadgeTemplate represents a configurable achievement program template that defines the rules, criteria, and rewards for earning badges within a client's organization. It serves as a blueprint for creating specific badge instances and supports check-in achievement types such as open gym, classes, appointments, and events.",
  example: {
    title: "Badge Title",
    description: "Badge Description",
    criteriaTotal: 12,
    criteria: {
      appointmentSelectionStrategy: "SPECIFIC",
      classSelectionStrategy: "ALL",
      includeEvents: true,
      includeOpenGym: false,
      selectedAppointmentTypeIds: ["apt-1", "apt-2"],
      selectedClassIds: ["class-1", "class-2"]
    },
    uuid: "123",
    startTime: "2021-01-01T00:00:00.000Z",
    endTime: "2021-01-01T00:00:00.000Z",
    createdAt: "2021-01-01T00:00:00.000Z",
    updatedAt: "2021-01-01T00:00:00.000Z"
  }
};
var BadgeSchema = {
  type: "object",
  properties: {
    uuid: {
      type: "string"
    },
    companyUuid: {
      type: "string"
    },
    title: {
      type: "string"
    },
    description: {
      type: "string",
      nullable: true
    },
    startTime: {
      type: "string"
    },
    endTime: {
      type: "string",
      nullable: true
    },
    criteriaTotal: {
      type: "integer",
      minimum: 1
    },
    appointmentSelectionStrategy: {
      type: "string",
      nullable: true,
      enum: ["ALL", "NONE", "SPECIFIC"]
    },
    classSelectionStrategy: {
      type: "string",
      nullable: true,
      enum: ["ALL", "NONE", "SPECIFIC"]
    },
    includeEvents: {
      type: "boolean",
      nullable: true
    },
    includeOpenGym: {
      type: "boolean",
      nullable: true
    },
    selectedAppointmentTypeIds: {
      type: "array",
      nullable: true,
      items: {
        type: "string"
      }
    },
    selectedClassIds: {
      type: "array",
      nullable: true,
      items: {
        type: "string"
      }
    },
    isActive: {
      type: "boolean"
    },
    createdAt: {
      type: "string",
      nullable: true
    },
    updatedAt: {
      type: "string",
      nullable: true
    },
    badgesCount: {
      type: "integer",
      minimum: 0
    }
  },
  required: [
    "uuid",
    "companyUuid",
    "title",
    "description",
    "startTime",
    "endTime",
    "criteriaTotal",
    "isActive",
    "createdAt",
    "updatedAt",
    "badgesCount"
  ],
  description: "Badge represents a specific instance of a badge template.",
  example: {
    uuid: "bdg-48ec477c29fb0f2320f0",
    companyUuid: "client_8489a8463bc510",
    title: "Badge Title - November 2024",
    description: "Committed Club for the Committed Folks",
    startTime: "2024-11-01T06:00:00.000Z",
    endTime: "2024-12-01T06:59:59.000Z",
    criteriaTotal: 3,
    appointmentSelectionStrategy: "SPECIFIC",
    classSelectionStrategy: "ALL",
    includeEvents: true,
    includeOpenGym: false,
    selectedAppointmentTypeIds: ["apt-1", "apt-2"],
    selectedClassIds: ["class-1", "class-2"],
    isActive: true,
    createdAt: "2024-11-04T13:19:55.728Z",
    updatedAt: "2024-11-04T13:19:55.728Z",
    badgesCount: 0
  }
};

// src/client/utils.ts
var PATH_PARAM_RE = /\{[^{}]+\}/g;
var serializePrimitiveParam = ({
  allowReserved,
  name,
  value
}) => {
  if (value === void 0 || value === null) {
    return "";
  }
  if (typeof value === "object") {
    throw new Error(
      "Deeply-nested arrays/objects aren\u2019t supported. Provide your own `querySerializer()` to handle these."
    );
  }
  return `${name}=${allowReserved ? value : encodeURIComponent(value)}`;
};
var separatorArrayExplode = (style) => {
  switch (style) {
    case "label":
      return ".";
    case "matrix":
      return ";";
    case "simple":
      return ",";
    default:
      return "&";
  }
};
var separatorArrayNoExplode = (style) => {
  switch (style) {
    case "form":
      return ",";
    case "pipeDelimited":
      return "|";
    case "spaceDelimited":
      return "%20";
    default:
      return ",";
  }
};
var separatorObjectExplode = (style) => {
  switch (style) {
    case "label":
      return ".";
    case "matrix":
      return ";";
    case "simple":
      return ",";
    default:
      return "&";
  }
};
var serializeArrayParam = ({
  allowReserved,
  explode,
  name,
  style,
  value
}) => {
  if (!explode) {
    const joinedValues2 = (allowReserved ? value : value.map((v) => encodeURIComponent(v))).join(separatorArrayNoExplode(style));
    switch (style) {
      case "label":
        return `.${joinedValues2}`;
      case "matrix":
        return `;${name}=${joinedValues2}`;
      case "simple":
        return joinedValues2;
      default:
        return `${name}=${joinedValues2}`;
    }
  }
  const separator = separatorArrayExplode(style);
  const joinedValues = value.map((v) => {
    if (style === "label" || style === "simple") {
      return allowReserved ? v : encodeURIComponent(v);
    }
    return serializePrimitiveParam({
      allowReserved,
      name,
      value: v
    });
  }).join(separator);
  return style === "label" || style === "matrix" ? separator + joinedValues : joinedValues;
};
var serializeObjectParam = ({
  allowReserved,
  explode,
  name,
  style,
  value
}) => {
  if (value instanceof Date) {
    return `${name}=${value.toISOString()}`;
  }
  if (style !== "deepObject" && !explode) {
    let values = [];
    Object.entries(value).forEach(([key, v]) => {
      values = [
        ...values,
        key,
        allowReserved ? v : encodeURIComponent(v)
      ];
    });
    const joinedValues2 = values.join(",");
    switch (style) {
      case "form":
        return `${name}=${joinedValues2}`;
      case "label":
        return `.${joinedValues2}`;
      case "matrix":
        return `;${name}=${joinedValues2}`;
      default:
        return joinedValues2;
    }
  }
  const separator = separatorObjectExplode(style);
  const joinedValues = Object.entries(value).map(
    ([key, v]) => serializePrimitiveParam({
      allowReserved,
      name: style === "deepObject" ? `${name}[${key}]` : key,
      value: v
    })
  ).join(separator);
  return style === "label" || style === "matrix" ? separator + joinedValues : joinedValues;
};
var defaultPathSerializer = ({ path, url: _url }) => {
  let url = _url;
  const matches = _url.match(PATH_PARAM_RE);
  if (matches) {
    for (const match of matches) {
      let explode = false;
      let name = match.substring(1, match.length - 1);
      let style = "simple";
      if (name.endsWith("*")) {
        explode = true;
        name = name.substring(0, name.length - 1);
      }
      if (name.startsWith(".")) {
        name = name.substring(1);
        style = "label";
      } else if (name.startsWith(";")) {
        name = name.substring(1);
        style = "matrix";
      }
      const value = path[name];
      if (value === void 0 || value === null) {
        continue;
      }
      if (Array.isArray(value)) {
        url = url.replace(
          match,
          serializeArrayParam({ explode, name, style, value })
        );
        continue;
      }
      if (typeof value === "object") {
        url = url.replace(
          match,
          serializeObjectParam({
            explode,
            name,
            style,
            value
          })
        );
        continue;
      }
      if (style === "matrix") {
        url = url.replace(
          match,
          `;${serializePrimitiveParam({
            name,
            value
          })}`
        );
        continue;
      }
      const replaceValue = encodeURIComponent(
        style === "label" ? `.${value}` : value
      );
      url = url.replace(match, replaceValue);
    }
  }
  return url;
};
var createQuerySerializer = ({
  allowReserved,
  array,
  object
} = {}) => {
  const querySerializer = (queryParams) => {
    let search = [];
    if (queryParams && typeof queryParams === "object") {
      for (const name in queryParams) {
        const value = queryParams[name];
        if (value === void 0 || value === null) {
          continue;
        }
        if (Array.isArray(value)) {
          search = [
            ...search,
            serializeArrayParam({
              allowReserved,
              explode: true,
              name,
              style: "form",
              value,
              ...array
            })
          ];
          continue;
        }
        if (typeof value === "object") {
          search = [
            ...search,
            serializeObjectParam({
              allowReserved,
              explode: true,
              name,
              style: "deepObject",
              value,
              ...object
            })
          ];
          continue;
        }
        search = [
          ...search,
          serializePrimitiveParam({
            allowReserved,
            name,
            value
          })
        ];
      }
    }
    return search.join("&");
  };
  return querySerializer;
};
var getParseAs = (content) => {
  if (!content) {
    return;
  }
  if (content.startsWith("application/json") || content.endsWith("+json")) {
    return "json";
  }
  if (content === "multipart/form-data") {
    return "formData";
  }
  if (["application/", "audio/", "image/", "video/"].some(
    (type) => content.startsWith(type)
  )) {
    return "blob";
  }
  if (content.startsWith("text/")) {
    return "text";
  }
};
var getUrl = ({
  baseUrl,
  path,
  query,
  querySerializer,
  url: _url
}) => {
  const pathUrl = _url.startsWith("/") ? _url : `/${_url}`;
  let url = baseUrl + pathUrl;
  if (path) {
    url = defaultPathSerializer({ path, url });
  }
  let search = query ? querySerializer(query) : "";
  if (search.startsWith("?")) {
    search = search.substring(1);
  }
  if (search) {
    url += `?${search}`;
  }
  return url;
};
var mergeConfigs = (a, b) => {
  const config = { ...a, ...b };
  if (config.baseUrl?.endsWith("/")) {
    config.baseUrl = config.baseUrl.substring(0, config.baseUrl.length - 1);
  }
  config.headers = mergeHeaders(a.headers, b.headers);
  return config;
};
var mergeHeaders = (...headers) => {
  const mergedHeaders = new Headers();
  for (const header of headers) {
    if (!header || typeof header !== "object") {
      continue;
    }
    const iterator = header instanceof Headers ? header.entries() : Object.entries(header);
    for (const [key, value] of iterator) {
      if (value === null) {
        mergedHeaders.delete(key);
      } else if (Array.isArray(value)) {
        for (const v of value) {
          mergedHeaders.append(key, v);
        }
      } else if (value !== void 0) {
        mergedHeaders.set(
          key,
          typeof value === "object" ? JSON.stringify(value) : value
        );
      }
    }
  }
  return mergedHeaders;
};
var Interceptors = class {
  constructor() {
    this._fns = [];
  }
  clear() {
    this._fns = [];
  }
  exists(fn) {
    return this._fns.indexOf(fn) !== -1;
  }
  eject(fn) {
    const index = this._fns.indexOf(fn);
    if (index !== -1) {
      this._fns = [...this._fns.slice(0, index), ...this._fns.slice(index + 1)];
    }
  }
  use(fn) {
    this._fns = [...this._fns, fn];
  }
};
var createInterceptors = () => ({
  error: new Interceptors(),
  request: new Interceptors(),
  response: new Interceptors()
});
var jsonBodySerializer = {
  bodySerializer: (body) => JSON.stringify(body)
};
var defaultQuerySerializer = createQuerySerializer({
  allowReserved: false,
  array: {
    explode: true,
    style: "form"
  },
  object: {
    explode: true,
    style: "deepObject"
  }
});
var defaultHeaders = {
  "Content-Type": "application/json"
};
var createConfig = (override = {}) => ({
  ...jsonBodySerializer,
  baseUrl: "",
  fetch: globalThis.fetch,
  headers: defaultHeaders,
  parseAs: "auto",
  querySerializer: defaultQuerySerializer,
  ...override
});

// src/client/index.ts
var createClient = (config = {}) => {
  let _config = mergeConfigs(createConfig(), config);
  const getConfig = () => ({ ..._config });
  const setConfig = (config2) => {
    _config = mergeConfigs(_config, config2);
    return getConfig();
  };
  const interceptors = createInterceptors();
  const request = async (options) => {
    const opts = {
      ..._config,
      ...options,
      headers: mergeHeaders(_config.headers, options.headers)
    };
    if (opts.body && opts.bodySerializer) {
      opts.body = opts.bodySerializer(opts.body);
    }
    if (!opts.body) {
      opts.headers.delete("Content-Type");
    }
    const url = getUrl({
      baseUrl: opts.baseUrl ?? "",
      path: opts.path,
      query: opts.query,
      querySerializer: typeof opts.querySerializer === "function" ? opts.querySerializer : createQuerySerializer(opts.querySerializer),
      url: opts.url
    });
    const requestInit = {
      redirect: "follow",
      ...opts
    };
    let request2 = new Request(url, requestInit);
    for (const fn of interceptors.request._fns) {
      request2 = await fn(request2, opts);
    }
    const _fetch = opts.fetch;
    let response = await _fetch(request2);
    for (const fn of interceptors.response._fns) {
      response = await fn(response, request2, opts);
    }
    const result = {
      request: request2,
      response
    };
    if (response.ok) {
      if (response.status === 204 || response.headers.get("Content-Length") === "0") {
        return {
          data: {},
          ...result
        };
      }
      if (opts.parseAs === "stream") {
        return {
          data: response.body,
          ...result
        };
      }
      const parseAs = (opts.parseAs === "auto" ? getParseAs(response.headers.get("Content-Type")) : opts.parseAs) ?? "json";
      let data = await response[parseAs]();
      if (parseAs === "json" && opts.responseTransformer) {
        data = await opts.responseTransformer(data);
      }
      return {
        data,
        ...result
      };
    }
    let error = await response.text();
    try {
      error = JSON.parse(error);
    } catch {
    }
    let finalError = error;
    for (const fn of interceptors.error._fns) {
      finalError = await fn(error, response, request2, opts);
    }
    finalError = finalError || {};
    if (opts.throwOnError) {
      throw finalError;
    }
    return {
      error: finalError,
      ...result
    };
  };
  return {
    connect: (options) => request({ ...options, method: "CONNECT" }),
    delete: (options) => request({ ...options, method: "DELETE" }),
    get: (options) => request({ ...options, method: "GET" }),
    getConfig,
    head: (options) => request({ ...options, method: "HEAD" }),
    interceptors,
    options: (options) => request({ ...options, method: "OPTIONS" }),
    patch: (options) => request({ ...options, method: "PATCH" }),
    post: (options) => request({ ...options, method: "POST" }),
    put: (options) => request({ ...options, method: "PUT" }),
    request,
    setConfig,
    trace: (options) => request({ ...options, method: "TRACE" })
  };
};

// src/services.gen.ts
var client = createClient(createConfig());
var BadgesService = class {
  /**
   * Create a badge template
   * Endpoint to create a badge template for committed club
   */
  static create(options) {
    return (options?.client ?? client).post({
      ...options,
      url: "/badges/badge-templates"
    });
  }
  /**
   * Get badge template
   * Endpoint to get badge template for a company
   */
  static getBadgeTemplate(options) {
    return (options?.client ?? client).get({
      ...options,
      url: "/badges/badge-templates"
    });
  }
  /**
   * Update badge template
   * Endpoint to update badge template for a company
   */
  static update(options) {
    return (options?.client ?? client).patch({
      ...options,
      url: "/badges/badge-templates"
    });
  }
  /**
   * Get historical eligibility
   * Endpoint to get historical eligibility for a company
   */
  static getHistoricalEligibility(options) {
    return (options?.client ?? client).post({
      ...options,
      url: "/badges/historical-eligibility"
    });
  }
  /**
   * Get badges
   * Endpoint to get badges for a company
   */
  static getBadges(options) {
    return (options?.client ?? client).get({
      ...options,
      url: "/badges"
    });
  }
  /**
   * Get badge progress
   * Endpoint to get badge progress for a company
   */
  static getBadgeProgress(options) {
    return (options?.client ?? client).get({
      ...options,
      url: "/badges/badge-progress/{badgeUuid}"
    });
  }
  /**
   * Export badge progress
   * Endpoint to export badge progress for a company
   */
  static exportBadgeProgress(options) {
    return (options?.client ?? client).get({
      ...options,
      url: "/badges/badge-progress/{badgeUuid}/export"
    });
  }
  /**
   * Get member's badge progress
   * Endpoint to get member's progress for a specific badge
   */
  static getMemberBadgeProgress(options) {
    return (options?.client ?? client).get({
      ...options,
      url: "/badges/{badgeUuid}/member-progress"
    });
  }
  /**
   * Get badge members
   * Endpoint to get badge members
   */
  static getBadgeMembers(options) {
    return (options?.client ?? client).get({
      ...options,
      url: "/badges/{badgeUuid}/members"
    });
  }
  /**
   * Get active badge
   * Endpoint to get active badge for a company
   */
  static getActiveBadge(options) {
    return (options?.client ?? client).get({
      ...options,
      url: "/badges/active-badge"
    });
  }
};
var CompanyService = class {
  /**
   * Get the current company status
   */
  static getCompanyStatus(options) {
    return (options?.client ?? client).get({
      ...options,
      url: "/company/status"
    });
  }
  /**
   * Update the company's data for the Committed Club
   */
  static updateCompanyCommittedClub(options) {
    return (options?.client ?? client).post({
      ...options,
      url: "/company/committed-club"
    });
  }
  /**
   * Deactivate the company's app
   */
  static deactivateApp(options) {
    return (options?.client ?? client).post({
      ...options,
      url: "/company/deactivate"
    });
  }
};

// src/types.gen.ts
var appointmentSelectionStrategy = /* @__PURE__ */ ((appointmentSelectionStrategy2) => {
  appointmentSelectionStrategy2["ALL"] = "ALL";
  appointmentSelectionStrategy2["NONE"] = "NONE";
  appointmentSelectionStrategy2["SPECIFIC"] = "SPECIFIC";
  return appointmentSelectionStrategy2;
})(appointmentSelectionStrategy || {});
var classSelectionStrategy = /* @__PURE__ */ ((classSelectionStrategy2) => {
  classSelectionStrategy2["ALL"] = "ALL";
  classSelectionStrategy2["NONE"] = "NONE";
  classSelectionStrategy2["SPECIFIC"] = "SPECIFIC";
  return classSelectionStrategy2;
})(classSelectionStrategy || {});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  BadgeSchema,
  BadgeTemplateSchema,
  BadgesService,
  CompanyService,
  appointmentSelectionStrategy,
  classSelectionStrategy,
  client
});
